import { useCallback } from 'react';

import {
  useGetMyMcpAccessQuery,
  useMcpRevokeConnectionMutation,
} from 'gqlhooks';

export const useMyMcpAccess = () => {
  const { data, loading, error, refetch } = useGetMyMcpAccessQuery({
    // Подключения и счётчик вызовов меняются вне этой вкладки (клиент может
    // подключиться в любой момент), поэтому при возврате на страницу
    // перезапрашиваем, а не показываем кэш.
    fetchPolicy: 'cache-and-network',
  });

  return {
    access: data?.myMcpAccess,
    loading,
    error,
    refetch,
  };
};

export const useRevokeMcpConnection = () => {
  const [mutate, { loading }] = useMcpRevokeConnectionMutation();

  const revoke = useCallback(
    async (id: string) => {
      const { data } = await mutate({ variables: { id } });
      const result = data?.revokeMcpConnection;
      return {
        success: Boolean(result?.success),
        // Ошибку показываем текстом бэкенда: он единственный знает, почему
        // отказал (чужое подключение, уже отозвано и т.д.).
        message: result?.customErrors?.[0]?.message ?? '',
      };
    },
    [mutate],
  );

  return { revoke, loading };
};
